// 10 megabytes
export const MAX_FILE_SIZE = 10485760;

export enum EDocumentTypes {
    KTP = 'INDIVIDUAL_ID',
    Selfie = 'INDIVIDUAL_FACE',
    Signature = 'SPECIMEN_SIGNATURE',
    NPWP = 'INDIVIDUAL_TAXPAYER_CARD',
}
